import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { DataViewType } from '@/interfaces'
import { useViewType } from '@/composables'
import { getRouteName } from '@/services/utils'
import { isSideContainerVisible } from '@/components/common/SideContainer/utils'

export enum ResizeHandleTypeRoutes {
  Videos = 'videos',
  Folders = 'folders',
  ViewFolder = 'view-folder',
  Playlists = 'playlists',
  MyPackages = 'packages',
  OfferedPackages = 'offered-packages',
  AiGenerated = 'ai-generated',
  PendingAiGenerated = 'pending-ai-generated'
}

export function useViewportResizeHandleType(breakpoint = 992) {
  const viewportWidth = ref(window.innerWidth)
  const { viewType } = useViewType()
  const viewTypeBasedOnResize = ref<DataViewType>(viewType.value)
  const setDataViewTypeBasedOnViewport = (): void => {
    if (isSideContainerVisible()) return
    const routeName = getRouteName()
    viewportWidth.value = window.innerWidth
    if (viewportWidth.value <= breakpoint && Object.values(ResizeHandleTypeRoutes).includes(routeName as ResizeHandleTypeRoutes)) {
      viewTypeBasedOnResize.value = DataViewType.Grid
    } else {
      viewTypeBasedOnResize.value = viewType.value
    }
  }

  onMounted(() => {
    window.addEventListener('resize', setDataViewTypeBasedOnViewport)
    setDataViewTypeBasedOnViewport()
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', setDataViewTypeBasedOnViewport)
  })

  watch(
    () => viewType.value,
    () => {
      viewTypeBasedOnResize.value = viewType.value
    }
  )

  return {
    viewTypeBasedOnResize
  }
}
